import type { GraphVisualizationFrame } from "@salesko/contracts";

const GraphFrameBadgeFallback = "Relationship graph";
const GraphVisualizationContractPattern = /\s*(?:\u00b7|\|)\s*graph\.visualization\.v1\b/gi;
const TrailingGraphVisualizationContractPattern = /\s+-\s+graph\.visualization\.v1\b\s*$/i;
const TrailingNodeCountPattern = /\s*(?:\u00b7|\|)\s*\d+\s+nodes?\s*$/i;

export function graphFrameBadgeLabel(frame: GraphVisualizationFrame, fallbackLabel = GraphFrameBadgeFallback) {
  const summary = frame.summary.trim();
  if (!summary || summary === frame.schemaVersion) {
    return fallbackLabel;
  }

  const compact = stripGraphVisualizationContract(summary).replace(TrailingNodeCountPattern, "").trim();
  return compact || fallbackLabel;
}

export function graphFrameBadgeTitle(frame: GraphVisualizationFrame, fallbackLabel = GraphFrameBadgeFallback) {
  const summary = frame.summary.trim();
  if (!summary) {
    return fallbackLabel;
  }

  return stripGraphVisualizationContract(summary) || fallbackLabel;
}

function stripGraphVisualizationContract(value: string) {
  return value
    .replace(TrailingGraphVisualizationContractPattern, "")
    .replace(GraphVisualizationContractPattern, "")
    .replace(/\s*(?:\u00b7|\|)\s*(?:\u00b7|\|)\s*/g, " · ")
    .replace(/^\s*(?:\u00b7|\|)\s*|\s*(?:\u00b7|\|)\s*$/g, "")
    .trim();
}
